'use client'

import { useCallback } from 'react'
import type { Cart } from '@booking/types/booking'

import { payTransaction } from '@booking/services/api'
import { insertScript } from '@booking/lib/dom'
import { mapLocaleToGateway } from '../lib/paymentLocale'
import { useBookingActionsCtx } from '../../../state/booking.context'

type Args = {
  locale: string
  email: string
}

export function useGatewayCard({ locale, email }: Args) {
  const { dispatch } = useBookingActionsCtx()

  const startCardPayment = useCallback(
    async ({ cart }: { cart: Cart }) => {
      const res = await payTransaction(cart.id, 'REDUNIQ', {
        customerEmail: email,
      })

      if (res) dispatch({ type: 'SET_CART', cart: res.cart })

      window.wpwlOptions = {
        style: 'plain',
        locale: mapLocaleToGateway(locale),
        paymentTarget: '_top',
        billingAddress: {},
        brandDetection: true,
        mandatoryBillingFields: {
          country: false,
          state: false,
          city: true,
          postcode: true,
          street1: true,
          street2: false,
        },
      }

      if (!res) return
      if (res.payment && res.payment.scriptPath) insertScript(res.payment.scriptPath)
    },
    [dispatch, email, locale],
  )

  return { startCardPayment }
}
